module.exports = __webpack_public_path__ + "assets/8feee2e0816f1555c9b6da8ef5bf248a.json";